import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LockIcon from '@mui/icons-material/Lock';
import BaseSelectionBox from '@artemis/components/SelectionBox';
import { FormattedMessage } from '@artemis/integrations/contentful/utils';

const Container = styled.li`
  list-style: none;
`;

const RadioContainer = styled(BaseSelectionBox)`
  padding: 16px;
  border-bottom: 1px solid ${props => props.theme.rtColors.black200};
  justify-content: space-between;
`;

const Name = styled.p`
  font-weight: ${props => props.theme.typography.fontWeightMedium};
`;

const SecondaryDetails = styled.div`
  display: flex;
  align-items: center;
`;

const SecureLabel = styled.div`
  display: flex;
  align-items: center;
  > svg {
    margin-right: 8px;
    font-size: 16px;
  }
  > span {
    font-size: 14px;
  }
`;

const Caption = styled.span`
  color: ${props => props.theme.rtColors.black700};
  font-size: 14px;
`;

const Separator = styled.span`
  color: ${props => props.theme.rtColors.black700};
  margin: 0 4px;
`;

const TeamSelectionBox = ({
  id,
  name,
  secured = false,
  caption,
  onSelect,
  selected = false,
  ...props
}) => (
  <Container>
    <RadioContainer
      labelPosition="left"
      onClick={() => onSelect(id)}
      selected={selected}
      {...props}
    >
      {/* Extra <div> to separate content from the radio button */}
      <div>
        <Name>{name}</Name>
        {(secured || caption) && (
          <SecondaryDetails>
            {secured && (
              <SecureLabel>
                <LockIcon />
                <span>
                  <FormattedMessage entry="teams.secure" />
                </span>
              </SecureLabel>
            )}
            {secured && caption && <Separator>•</Separator>}
            {caption && <Caption>{caption}</Caption>}
          </SecondaryDetails>
        )}
      </div>
    </RadioContainer>
  </Container>
);

TeamSelectionBox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.node.isRequired,
  secured: PropTypes.bool,
  caption: PropTypes.node,
  onSelect: PropTypes.func,
  selected: PropTypes.bool,
};

export default TeamSelectionBox;
